import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const INPUT_TAX_SERIAL_REQUEST = 'sherrinford/tax/add/INPUT_TAX_SERIAL_REQUEST'
export const INPUT_TAX_SERIAL_SUCCESS = 'sherrinford/tax/add/INPUT_TAX_SERIAL_SUCCESS'
export const INPUT_TAX_SERIAL_ERROR = 'sherrinford/tax/add/INPUT_TAX_SERIAL_ERROR'

export const POST_TAX_INVOICE_REQUEST = 'sherrinford/tax/add/POST_TAX_INVOICE_REQUEST'
export const POST_TAX_INVOICE_SUCCESS = 'sherrinford/tax/add/POST_TAX_INVOICE_SUCCESS'
export const POST_TAX_INVOICE_ERROR = 'sherrinford/tax/add/POST_TAX_INVOICE_ERROR'

export const IS_LOADING = 'sherrinford/tax/add/IS_LOADING'
export const DATA = 'sherrinford/tax/add/DATA'

const initialState = {
  data: {
    serialNumber: '',
    isUsed: false,
    lowestLimit: 0,
    highestLimit: 1,
    frontDigit: '010',
    midDigit: '00',
    backDigit: '18',
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [INPUT_TAX_SERIAL_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [INPUT_TAX_SERIAL_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [INPUT_TAX_SERIAL_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [POST_TAX_INVOICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_TAX_INVOICE_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_TAX_INVOICE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [DATA]: (state, taxSerial) => {
    const { data } = taxSerial
    return {
      ...state,
      data,
    }
  },
})

export const setTaxSerial = (data, cb) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      INPUT_TAX_SERIAL_REQUEST,
      INPUT_TAX_SERIAL_SUCCESS,
      INPUT_TAX_SERIAL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/tax_serial',
      payloads: data,
      authorization: `${token}`,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export function postTaxInvoice(payloads, cb = () => {}) {
  return {
    type: [
      POST_TAX_INVOICE_REQUEST,
      POST_TAX_INVOICE_SUCCESS,
      POST_TAX_INVOICE_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/tax_invoice',
      payloads,
    },
    nextAction: res => cb(res),
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
